import React from "react";
import classes from "./ConvincingItem.module.css";

export default function ConvincingItem(props) {
  return (
    <div className={classes.container}>
      <div className={classes.itemIcon} />
      <span className={classes.convincingText}>{props.itemText}</span>
    </div>
  );
}
